import { render, staticRenderFns } from "./Topdesign.vue?vue&type=template&id=35298158&"
import script from "./Topdesign.vue?vue&type=script&lang=js&"
export * from "./Topdesign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports